export class LoadingProgress  {
  isLoading: boolean;
  results: string;

  constructor() {
    this.isLoading = false;
    this.results = "";
  }
  setLoading() {
    this.isLoading = true;
    this.results = "";
  }
  setRes(res: string) {
    this.isLoading = false;
    this.results = res;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/ILoadingProgress.ts